// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportingConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';

export default withHandlers({
  /**
   * Cancel Change config
   */
  cancelChangeConfig: props => () => {
    const { localization, store, validation } = props;
    const { alertDetails } = store;
    validation.reset();
    resetAlert(props);
    if (!store.isDirty) {
      setAlertDetails(alertDetails, null, localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
    } else {
      return props
        .confirmFn('Confirmation', {
          description: localization.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
        })
        .then(() => {
          store.loadExportingConfiguration();
        });
    }
  },

  /**
   * Save exporting config
   */
  saveConfig: props => () => {
    const { localization, store, loader, validation } = props;
    const { alertDetails } = store;
    resetAlert(props);
    if (!store.isDirty) {
      setAlertDetails(alertDetails, null, localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
    } else {
      return validation.validate().then(success => {
        if(success){
          return props
          .confirmFn('Confirmation', {
            description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
          })
          .then(() => {
            loader.startLoading();
            return store.saveExportingConfiguration().then(res => {
              if (res.success) {
                setAlertDetails(alertDetails, true, localization.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'));
              }else{
                validation.updateErrors(res.messages);
              }
            });
          })
          .finally(loader.endLoading.bind(loader));
        }
        return null;
      });
    }
  },

  /**
   * Reset alert details
   */
  resetAlert: props => () => resetAlert(props)
});
const resetAlert = props => {
  return props.store.alertDetails.reset();
};
const setAlertDetails = (alertDetails: any, success: any, message: string) => {
  alertDetails.set({
    success: success,
    message: message
  });
};



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Exporting/Izenda.ExportingConfigurationActions.js